document.addEventListener("DOMContentLoaded", function () {
  var faqSections = document.querySelectorAll("[data-home-faq]");

  faqSections.forEach(function (section) {
    var items = section.querySelectorAll(".home-faq__item");

    items.forEach(function (item) {
      var trigger = item.querySelector("[data-home-faq-trigger]");
      var panel = item.querySelector("[data-home-faq-panel]");
      var icon = item.querySelector(".home-faq__icon");

      if (!trigger || !panel || !icon) {
        return;
      }

      trigger.addEventListener("click", function () {
        var shouldOpen = trigger.getAttribute("aria-expanded") !== "true";

        items.forEach(function (currentItem) {
          var currentTrigger = currentItem.querySelector("[data-home-faq-trigger]");
          var currentPanel = currentItem.querySelector("[data-home-faq-panel]");
          var currentIcon = currentItem.querySelector(".home-faq__icon");

          if (!currentTrigger || !currentPanel || !currentIcon) {
            return;
          }

          currentItem.classList.remove("home-faq__item--open");
          currentTrigger.setAttribute("aria-expanded", "false");
          currentPanel.hidden = true;
          currentIcon.textContent = "+";
        });

        if (shouldOpen) {
          item.classList.add("home-faq__item--open");
          trigger.setAttribute("aria-expanded", "true");
          panel.hidden = false;
          icon.textContent = "-";
        }
      });
    });
  });
});
